import React, { useEffect, useState } from 'react';

// import { AddCardInfoModal } from '../../common/AddCardInfoModal';
// import { AddNewBipCard } from '../../common/AddNewBipCard';
// import { AddNewCard } from '../../common/AddNewCard';
// import ApiUrls from '../../../services/apiUrls';
// import { AppData } from '../../../services';
import BIP from './components/BIP';
// import { BipComingSoonModal } from '../../common/BipComingSoonModal';
import CommonService from '../../../../services/commonService';
import EnvironmentalImpact from './components/EnvironmentalImpact';
import {
  AddCardInfoModal,
  AddNewBipCard,
  AddNewCard,
  KuposErrorSuccessModal,
} from '../../../common';
import MenuItems from './components/MenuItems';
import MyCards from './components/MyCards';
import QrImage from './components/QrImage';
import { AppData } from '../../../../services';
import ApiUrls from '../../../../services/apiUrls';
import { EditCard } from '../../../common/EditCard';
import { DeleteCard } from '../../../common/DeleteCard';
import { BipComingSoonModal } from '../../../common/BipComingSoonModal';
import { DeleteBipCard } from '../../../common/DeleteBipCard';
import { EditBipCard } from '../../../common/EditBipCard';
import getIcons from '../../functions/getIcons/getIcons';

function MainTabsBodyMyAccount(props) {
  let track = null;
  const [items, setItems] = useState([
    // { icon: '/static/images/circular/qr.png', label: 'MY_QR' },
    // { icon: '/static/images/icon_bip.png', label: 'MY_BIP' },
    { icon: getIcons('trips', props.operator), label: 'MY_TRAVELS' },
    { icon: getIcons('cards', props.operator), label: 'MY_CARDS' },
    // { icon: '/static/images/circular/piggy-bank.png', label: 'MY_STATISTICS' },
    // { icon: '/static/images/circular/enfironment.png', label: 'ENVIRONMENTAL_EFFECTS' },
  ]);
  const [bipItems, setBipItems] = useState([]);
  const [titleDescItems, setTitleDescItems] = useState([
    { title: 'PROFILE.KM_RECORDED', desc: '150' },
    { title: 'PROFILE.CO2_SAVED', desc: '7.3M' },
    { title: 'PROFILE.PLANTED_TREES', desc: '1.23M' },
    { title: 'PROFILE.SAVED_MONEY', desc: 'CLP $6000' },
  ]);
  const [envItems, setEnvItems] = useState([
    {
      date: '30-04-2020',
      img: '/static/images/circular/enfironment.png',
      service: 'KuposPool',
      region: 'Santiago Centro - Quinta Normal',
      percentage: '90',
    },
    {
      date: '30-04-2020',
      img: '/static/images/circular/enfironment.png',
      service: 'TrenCentral',
      region: 'Santiago Centro - Quinta Normal',
      percentage: '80',
    },
  ]);
  const [myCards, setMyCards] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [bipAdminScreen, setBipAdminScreen] = useState(false);
  const [showDeleteBIPCard, setShowDeleteBIPCard] = useState(false);
  const [showEditBipCard, setShowEditBipCard] = useState(false);
  const [showAddBIPCard, setShowAddBIPCard] = useState(false);
  const [selectedItemForDeletion, setSelectedItemForDeletion] = useState(null);
  const [selectedItemForEdit, setSelectedItemForEdit] = useState(null);
  const [noCards, setNoCards] = useState(true);
  const [cardInFocus, setCardInFocus] = useState(0);
  const [bipCardToEdit, setBipCardToEdit] = useState(null);
  const [bipCardToDelete, setBipCardToDelete] = useState(null);
  const [cardTypes, setCardTypes] = useState(props.metaData ? props.metaData.card_type : null);
  const [showSuccessFailureModal, setShowSuccessFailureModal] = useState(null);
  const [showSuccessFailureModalStatus, setShowSuccessFailureModalStatus] = useState(null);
  const [showSuccessFailureModalBodyText, setShowSuccessFailureModalBodyText] = useState(null);

  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [showPaymentsOptions, setShowPaymentsOptions] = useState(null);
  const [envData, setEnvData] = useState(null);
  const [bipComingSoonModal, setBipComingSoonModal] = useState(null);
  const [bipRechargeAmount, setBipRechargeAmount] = useState(null);
  const [bipRechargeAmountError, setBipRechargeAmountError] = useState(null);
  const [showCardAddInfoModal, setShowCardAddInfoModal] = useState(null);
  const [showDeleteCard, setShowDeleteCard] = useState(null);
  const [showAddCard, setShowAddCard] = useState(null);
  const [showEditCard, setShowEditCard] = useState(null);
  const [selectedItemForEditAddCard, setSelectedItemForEditAddCard] = useState(null);
  const [initialRender, setInitialRender] = useState(true);

  // const getBipCards = () => {
  //   props.actions
  //     .apiCall({
  //       url: AppData.BIP_URL + 'api/v1/myCard/' + props.data.loginData.id,
  //     })
  //     .then(
  //       res => onBipCardsFetchResponse(res),
  //       err => onBipCardsFetchResponse(err),
  //     );
  // };

  // COMPONENT DID MOUNT
  useEffect(() => {
    // getBipCards();

    console.log('Data =---------------------', cardTypes);
    props.actions.getProfile({ url: ApiUrls.profile() }).then(
      (res) => {
        if (res && res.error) {
          return;
        } else if (res && res.auth_token) {
          CommonService.storeLoginDetails(res, props.actions.setLoginData);
        }
      },
      (err) => {
        if (err && err.status && err.status == 401) {
          CommonService.logout();
          props.history.push('/');
        }
      },
    );

    // props.actions.getOperatorPay({ url: ApiUrls.operatorPay() }).then(
    //   res => {
    //     debugger
    //     // if (res && res.error) {
    //     //   return;
    //     // } else if (res && res.auth_token) {
    //     //   CommonService.storeLoginDetails(res, props.actions.setLoginData);
    //     // }
    //   },
    //   err => {
    //     debugger
    //     // if (err && err.status && err.status == 401) {
    //     //   CommonService.logout();
    //     //   props.history.push('/');
    //     // }
    //   },
    // );

    console.log('Props are----------main tabs body----------', props);

    props.actions.apiCall({ url: AppData.BASE_URL + 'api/env_stats', type: 'home' }).then(
      (res) => onEnvDataFetch(res),
      (err) => onEnvDataFetch(err),
    );

    getOneClickCards();
  }, []);

  const getOneClickCards = () => {
    //Get one click cards
  
    let operator = JSON.parse(localStorage.getItem('metaData') || '{}');
    let operatorId = operator && operator.operator_sites && operator.operator_sites.operator.operator_id &&  operator.operator_sites.operator.operator_id;
    let operator_id = props.operator &&   props.operator.operator_id  ?  props.operator.operator_id  : operatorId;
    let queryParams='';
    if (CommonService.shouldPassOperatorId(operator)) {
      queryParams ='operator_id='+ CommonService.getOperatorId(operator)
    }

    props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/my_cards_list?'+queryParams,
        type: 'home',
      })
      .then(
        (res) => onOneClickCardsFetch(res),
        (err) => onOneClickCardsFetch(err),
      );
  };

  const profileApi = () => {
    let operator = JSON.parse(localStorage.getItem('metaData') || '{}');
    let operatorId = operator && operator.operator_sites && operator.operator_sites.operator.operator_id &&  operator.operator_sites.operator.operator_id;
    let operator_id = props.operator &&   props.operator.operator_id  ?  props.operator.operator_id  : operatorId;
     props.actions.apiCall({ url: AppData.BASE_URL + 'api/customer/profile?operator_id=' + operator_id, type:'home', noRedirect:true}).then(
      res => {   
        if (res && res.error) {
          return;
        } else if (res && res.data.auth_token) {
          CommonService.storeLoginDetails(res.data, props.actions.setLoginData);
          
        }
      },
      err => {},
    );
  }

  const onOneClickCardsFetch = (result) => {
    console.log('Cards detauls from backend ----------', result);
    if (result && result.data && result.data.card_details) {
      setMyCards(result.data.card_details);
    } else if (result.data.status === 401) {
      setMyCards([]);
    }

    setShowPaymentsOptions(true);
  };

  const onEnvDataFetch = (result) => {
    console.log('env data fetched -------------------', result);

    if (result && result.data) {
      setEnvData(result.data);
    }
  };

  // const onBipCardsFetchResponse = result => {
  //   if (result && result.data && result.data.success && result.data.data) {
  //     setBipItems(result.data.data);
  //   }
  //   console.log('Bip cards from api are ', result);
  // };

  const onItemClick = (val, i) => {
    if (val.label == 'MY_QR') {
      props.actions.getQr();
      setSelectedItem(val);
    } else if (val.label == 'MY_BIP') {
      setBipComingSoonModal(true);
    } else if (val.label === 'MY_TRAVELS') {
      props.onMenuChange(props.operator && props.operator.is_couponera_enabled ? 2 : 1);
    } else if (val.label == 'ENVIRONMENTAL_EFFECTS') {
      setSelectedItem(val);
    } else if (val.label == 'MY_CARDS') {
      setSelectedItem(val);
    }
  };

  const renderItemContent = () => {
    console.log('Selected Item', selectedItem);
    if (selectedItem.label == 'MY_QR') {
      return <QrImage t={props.t} setSelectedItem={setSelectedItem} data={props.data} />;
    } else if (selectedItem.label == 'MY_BIP') {
      return (
        <BIP
          bipItems={bipItems}
          bipAdminScreen={bipAdminScreen}
          setBipAdminScreen={setBipAdminScreen}
          setSelectedItem={setSelectedItem}
          setShowAddBIPCard={setShowAddBIPCard}
          setCardInFocus={setCardInFocus}
          bipRechargeAmountError={bipRechargeAmountError}
          bipRechargeAmount={bipRechargeAmount}
          onBipRechargeAmountBlur={onBipRechargeAmountBlur}
          onBipRechargeAmountChange={onBipRechargeAmountChange}
          goToBipRecharge={goToBipRecharge}
          showBipEditPopup={showBipEditPopup}
          showBipDeletePopup={showBipDeletePopup}
          cardInFocus={cardInFocus}
          track={track}
          t={props.t}
        />
      );
    } else if (selectedItem.label == 'ENVIRONMENTAL_EFFECTS') {
      return (
        <EnvironmentalImpact
          t={props.t}
          setSelectedItem={setSelectedItem}
          // renderTitleDesc={renderTitleDesc}
          titleDescItems={titleDescItems}
          envData={envData}
        />
      );
    } else if (selectedItem.label == 'MY_CARDS') {
      return (
        <MyCards
          t={props.t}
          setSelectedItem={setSelectedItem}
          myCards={myCards}
          setShowCardAddInfoModal={setShowCardAddInfoModal}
          cardTypes={cardTypes}
          setShowDeleteCard={setShowDeleteCard}
          operator={props.operator}
          setSelectedItemForDeletion={setSelectedItemForDeletion}
        />
      );
    }
  };

  const showBipEditPopup = (val) => {
    setBipCardToEdit(val);

    setTimeout(() => {
      setShowEditBipCard(true);
    }, 100);
  };

  const showBipDeletePopup = (val) => {
    setBipCardToDelete(val);

    setTimeout(() => {
      setShowDeleteBIPCard(true);
    }, 100);
  };

  const onBipRechargeAmountChange = (val) => {
    setBipRechargeAmount(val);
    setBipRechargeAmountError(null);
  };

  const onBipRechargeAmountBlur = (val) => {
    if (!val) {
      setBipRechargeAmountError({
        message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT',
      });
    }
  };

  const goToBipRecharge = () => {
    if (!bipRechargeAmount) {
      setBipRechargeAmountError({
        message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT',
      });
      return;
    }

    console.log('amount -----------------', bipRechargeAmount);

    if (bipRechargeAmount < 2000 || bipRechargeAmount > 25000) {
      setBipRechargeAmountError({
        message: 'VALIDATIONS.INSERT_RECHARGE_AMOUNT_LIMIT',
      });
      return;
    }
    console.log('ALL GOOD AND PROPS ARE ', props);
    let data = {
      cardNumber: bipItems[cardInFocus].card_number,
      amount: bipRechargeAmount,
      email: bipItems[cardInFocus].email,
      confirmEmail: bipItems[cardInFocus].email,
      isMyCard: 'my_card',
    };
    console.log('Inside bip recharge and data is ', data);
    props.actions.saveBipDetails(data);
    props.history.push('/bip-payment');
  };

  const onMonthChange = (maskedValue, selectedYear, selectedMonth) => {
    console.log(maskedValue, selectedMonth);

    setSelectedYear(selectedYear);
    setSelectedMonth(selectedMonth);
  };

  const onAddBipCard = (result) => {
    setNoCards(false);

    if (result && result.data && result.data.success && result.data.data) {
      // getBipCards();

      setShowAddBIPCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(true);
      setShowSuccessFailureModalBodyText('VALIDATIONS.BIP_CARD_ADDED');
    } else {
      setShowAddBIPCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(false);
      setShowSuccessFailureModalBodyText(
        result.data.message == 'Ingresa una tarjeta bip! válida.'
          ? 'VALIDATIONS.INVALID_BIP_CARD'
          : result.data.message,
      );
    }

    // console.log('Result from add card in main tabs', result);
  };

  const onBipCardUpdate = (result) => {
    if (result && result.data && result.data.success && result.data.data) {
      // getBipCards();

      setShowEditBipCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(true);
      setShowSuccessFailureModalBodyText('VALIDATIONS.BIP_CARD_UPDATED');
    } else {
      setShowEditBipCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(false);
      setShowSuccessFailureModalBodyText(result.data.message || 'Failure!');
    }
  };

  const onBipCardDelete = (result) => {
    if (result && result.data && result.data.success && result.data.data) {
      // getBipCards();

      setShowDeleteBIPCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(true);
      setShowSuccessFailureModalBodyText('VALIDATIONS.BIP_CARD_REMOVED');
    } else {
      setShowDeleteBIPCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(false);
      setShowSuccessFailureModalBodyText(result.data.message || 'Failure!');
    }
  };

  const onCardRemoved = (result) => {
   
    if (result && result.data && result.data.message === 'successfully Removed') {
      getOneClickCards();
      profileApi();
      setShowDeleteCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(true);
      setShowSuccessFailureModalBodyText('TRANSLATIONS.CARD_REMOVED_SUCCESS');
    } else {
      setShowDeleteCard(false);
      setShowSuccessFailureModal(true);
      setShowSuccessFailureModalStatus(false);
      setShowSuccessFailureModalBodyText('TRANSLATIONS.CARD_REMOVED_FAILURE');
    }
  };

  const addOneClickCard = () => {
    localStorage.setItem('appType', 'one_click');
    let operator = JSON.parse(localStorage.getItem('metaData') || '{}');
    let operatorId = operator && operator.operator_sites && operator.operator_sites.operator.operator_id &&  operator.operator_sites.operator.operator_id;
    let operator_id = props.operator && props.operator.operator_id ? props.operator.operator_id : operatorId;
   
    let queryParams='';
    if (CommonService.shouldPassOperatorId(operator)) {
      queryParams ='operator_id='+ CommonService.getOperatorId(operator)
    }

    props.actions
      .apiCall({
        url: AppData.BASE_URL + 'api/kupos_add_cards?' + queryParams,
        type: 'home',
        method: 'POST',
        data:{
          base_url: window.location.protocol + '//' + window.location.host
        }
      })
      .then(
        (res) => onAddCard(res),
        (err) => onAddCard(err),
      );
  };

  const onAddCard = (result) => {
    console.log('onAddCard------------------------', result);

    if (result && result.data && result.data.html_str) {
      setShowCardAddInfoModal(false);
      localStorage.setItem('paymentGatewayOpened', true);
      document.write(result.data.html_str);
    }
  };

  // console.log('Bip cards are', this.state.bipItems);
  // console.log('Env data ------------------------------', this.state.envData);
  const { t } = props;
  return (
    <div
      className={
        'sub-section-description scroll-style ' +
        (selectedItem && selectedItem.label == 'MY_BIP' ? 'bip-selection-container' : '')
      }
    >
      {selectedItem === null ? (
        <div className="my-account-title center-text">
          <div className="sub-section-account-general-title font13">
            {t('PROFILE.MY_MENUS_HEADING.NORMAL')}{' '}
            <span className="bold-text">{t('PROFILE.MY_MENUS_HEADING.BOLD')}</span>
          </div>
          <div className="sub-section-account-general-description font11">
            {t('PROFILE.MY_MENUS_DESCRIPTION')}
          </div>
        </div>
      ) : null}

      {selectedItem === null ? (
        <div className="sub-section-body">
          <div className="account-general-items font10 bold-text">
            {items.map((val, key) => (
              <MenuItems
                val={val}
                key={key}
                data={props.data}
                onItemClick={onItemClick}
                setShowSuccessFailureModal={setShowSuccessFailureModal}
                setShowSuccessFailureModalStatus={setShowSuccessFailureModalStatus}
                setShowSuccessFailureModalBodyText={setShowSuccessFailureModalBodyText}
                t={props.t}
              />
            ))}
          </div>
        </div>
      ) : (
        renderItemContent()
      )}

      <AddNewCard
        showModal={showAddCard}
        onHide={() => setShowAddCard(false)}
        common={props.common}
        onAddCard={() => {
          setNoCards(false);
          setShowAddCard(false);
        }}
        t={props.t}
      />

      <EditCard
        showModal={showEditCard}
        onHide={() => setShowEditCard(false)}
        userCards={myCards}
        selectedItemForEdit={selectedItemForEditAddCard}
        t={props.t}
      />

      <DeleteCard
        showModal={showDeleteCard}
        onHide={() => setShowDeleteCard(false)}
        userCards={myCards}
        selectedItemForDeletion={selectedItemForDeletion}
        data={props.data}
        actions={props.actions}
        t={props.t}
        onCardRemoved={onCardRemoved}
        operator={props.operator}
      />

      <BipComingSoonModal
        showModal={bipComingSoonModal}
        onHide={() => setBipComingSoonModal(false)}
        image={t('HOME.BIP_SOON_IMAGE')}
        metaData={props.metaData}
      />

      <AddNewBipCard
        showModal={showAddBIPCard}
        onHide={() => setShowAddBIPCard(false)}
        common={props.common}
        onAddCard={onAddBipCard}
        actions={props.actions}
        data={props.data}
        t={props.t}
      />

      {bipCardToEdit ? (
        <EditBipCard
          showModal={showEditBipCard}
          onHide={() => setShowEditBipCard(false)}
          userCards={bipItems}
          selectedItemForEdit={bipCardToEdit}
          onBipCardUpdate={onBipCardUpdate}
          data={props.data}
          actions={props.actions}
          t={props.t}
        />
      ) : null}

      {bipCardToDelete ? (
        <DeleteBipCard
          showModal={showDeleteBIPCard}
          onHide={() => setShowDeleteBIPCard(false)}
          userCards={bipItems}
          selectedItemForDeletion={bipCardToDelete}
          onBipCardDelete={onBipCardDelete}
          data={props.data}
          actions={props.actions}
          t={props.t}
        />
      ) : null}

      <KuposErrorSuccessModal
        success={showSuccessFailureModalStatus}
        showModal={showSuccessFailureModal}
        title={
          showSuccessFailureModalStatus ? props.t('HOME.THANK_YOU') : props.t('HOME.WE_ARE_SORRY')
        }
        onButtonClick={() => setShowSuccessFailureModal(false)}
        bodyText={showSuccessFailureModalBodyText}
        t={props.t}
        generalButton={showSuccessFailureModalStatus ? props.t('OK') : props.t('PROFILE.GO_BACK')}
        operator={props.operator}
      />

      <AddCardInfoModal
        showModal={showCardAddInfoModal}
        onHide={() => setShowCardAddInfoModal(false)}
        icon={getIcons('failure', props.operator)}
        // icon={'/static/images/warning.png'}
        t={props.t}
        addCard={addOneClickCard}
        operator={props.operator}
      />
    </div>
  );
}

export default MainTabsBodyMyAccount;




// WEBPACK FOOTER //
// ./src/features/themes/my-account/MainTabsBodyMyAccount/MainTabsBodyMyAccount.js